import FrontRow from "../images/frontrow.png"
import EduConnect from "../images/educonnect.png"
import MyShare from "../images/myshare.png"
import MyResume from "../files/My_Resume.pdf"
import Express from "../images/express.png"
import Node from "../images/node.png"
import Go from "../images/go.png"
import HomePage from "../images/HomePage.png"
import Git from "../images/git.svg"
import Vercel from "../images/vercel.png"
import Adobe from "../images/adobe.png"
import Postman from "../images/postman.svg"
import Figma from "../images/figma"
import Tailwind from "../images/tailwind"
import Render from "../images/Render.png"
import Docker from "../images/docker.png"
import BloodLink from "../images/BloodLink.png"


export const Bio = {
  name: "Souvik Ghosh",
  roles: [
    "FullStack Developer",
    "Web3 Enthusiast",
    "UI/UX Designer",
    
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/souvikree",
  resume: MyResume,
  linkedin: "https://www.linkedin.com/in/souvik-ghosh-97a208227/",
  twitter: "https://x.com/reek_me",
  instagram: "https://www.instagram.com/script.reek/",
  facebook: "https://www.facebook.com/profile.php?id=100075046226959",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Tailwindcss",
        image:Tailwind,
      },
      {
        name: "Material UI",
        image:
       "data:image/png;base64,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",
      },
      // {
      //   name: "Flutter",
      //   image:
      //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      // },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: Node,
      },
      {
        name: "Express Js",
        image: Express
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  {
      title: "Programming Skills",
      skills: [
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "C",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
        },
        {
          name: "Go",
          image:Go ,
        },
      ],
    },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:Git,
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Vercel",
        image: Vercel,
      },
      {
        name: "Render",
        image: Render,
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
         image: Postman ,    //"https://cdn.iconscout.com/icon/free/png-256/free-postman-3521648-2945092.png"
       },
      {
        name: "Adobe XD",
        image: Adobe, 
      },
      {
        name: "Figma",
        image:Figma ,
      },
      {
        name: "Docker",
        image: Docker,
      },
    ],
  },
];

export const experiences = [
  // {
  //   id: 0,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
  //   role: "DevOps & Fullstack Engineering Intern",
  //   company: "Flipr Inovations Pvt. Ltd.",
  //   date: "Aug 2023 - July 2023",
  //   desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
  //   skills: [
  //     "Docker",
  //     "Terraform",
  //     "AWS",
  //     "EC2",
  //     "Portainer",
  //     "Nginx",
  //     "JavaScript",
  //     "TypeScript",
  //     "Node Js",
  //     " Next Js",
  //   ],
  //   doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  // },
  // {
  //   id: 0,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
  //   role: "Frontend Engineer Intern",
  //   company: "Neurobit",
  //   date: "June 2023 - Present",
  //   desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
  //   skills: [
  //     "ReactJS",
  //     "Redux",
  //     "NodeJs",
  //     "Material UI",
  //     "HTML",
  //     "CSS",
  //     "JavaScript",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  // },
  // {
  //   id: 1,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
  //   role: "Fullstack Externship",
  //   company: "Flipr",
  //   date: "June 2023 - July 2023",
  //   desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
  //   skills: [
  //     "ReactJS",
  //     "Redux",
  //     "NodeJs",
  //     "Material UI",
  //     "HTML",
  //     "CSS",
  //     "JavaScript",
  //     "Docker",
  //     "AWS",
  //     "MongoDB",
  //   ],
  // },
  // {
  //   id: 2,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
  //   role: "Open Source Contributor ",
  //   company: "GirlScript Summer of Code",
  //   date: "May 2023 - Present",
  //   desc: "Contributing to different open-source projects and learn from industry experts",
  //   doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
  // },
  // {
  //   id: 3,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
  //   role: "Android Developer",
  //   company: "DSC KIIT",
  //   date: "Nov2021 - Present",
  //   desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
  //   skills: [
  //     "Leadership",
  //     "Mobile Application Development",
  //     "Kotlin",
  //     "XML",
  //     "Figma",
  //   ],
  // },
  // {
  //   id: 4,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
  //   role: "Android Developer Intern",
  //   company: "Rudraksha Welffare Foundation",
  //   date: "June 2021 - Oct 2021",
  //   desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
  //   skills: [
  //     "Android",
  //     "Java",
  //     "Kotlin",
  //     "XML",
  //     "Node Js",
  //     "Cloud Firestore",
  //     "Firebase",
  //     "Figma",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  // },
];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/b/be/Heritage_Institute_of_Kolkata_Logo.png",
    school: "Heritage Institute of Technology, Kolkata",
    date: "Oct 2021 - Jun 2025",
    grade: "7.53 CGPA",
    desc: "I have completed my Bachelor's degree in Computer Science and Business Systems from the Heritage Institute of Technology, Kolkata. With a CGPA of 7.11, my coursework includes Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among other subjects. Now in my 4th year, 7th semester, I am actively engaged in learning and working on exciting projects.",
    degree: "Bachelor of Technology - BTech, Computer Science and Business system",
  },
  {
    id: 1,
    img: "https://lh3.googleusercontent.com/p/AF1QipNjQqEmrW9_VNUCcQXShnHYuzCv5_Rw-fEsQLmx=s1360-w1360-h1020",
    school: "Bankura Banga Vidyalay, Bankura",
    date: "Apr 2019 - Apr 2021",
    grade: "89%",
    desc: "I completed my higher secondary education with a focus on Science at Bankura Banga Vidyalay, Bankura. This rigorous academic experience provided me with a solid foundation in scientific principles and critical thinking, which have been instrumental in my subsequent studies and professional development.",
    degree: "WBCHSE(XII), Science",
  },
  {
    id: 2,
    img: "https://lh3.googleusercontent.com/p/AF1QipNjQqEmrW9_VNUCcQXShnHYuzCv5_Rw-fEsQLmx=s1360-w1360-h1020",
    school: "Bankura Banga Vidyalay, Bankura",
    date: "Apr 2013 - Apr 2019",
    grade: "80%",
    desc: "I completed my secondary education at Bankura Banga Vidyalay, Bankura. This educational experience laid the groundwork for my academic and professional journey, equipping me with essential knowledge and skills.",
    degree: "WBBSC(X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "FrontRow",
    date: "Jun 2024 - Jul 2024",
    description:
      "Frontrow is a modern web application built with React.js, designed to streamline the process of booking movie tickets and managing user profiles seamlessly. It provides a user-friendly interface for users to explore movies, check showtimes, and book tickets conveniently.",
    image: FrontRow,
  
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "NodeMailer",
      "Tailwindcss",
    ],
    category: "web app",
    github: "https://github.com/souvikree/FrontRow",
    webapp: "https://buyfrontrow.netlify.app/",
    member: [
      {
        name: "Souvik Ghosh",
        img: "https://avatars.githubusercontent.com/u/143630779?v=4",
        linkedin: "https://www.linkedin.com/in/souvik-ghosh-97a208227/",
        github: "https://github.com/souvikree",
      },
      
    ],
  },
  {
    id: 1,
    title: "BloodLink",
    date: "Jan 2025 - May 2025",
    description:
      "BloodLink is a cutting-edge platform designed to address the critical issue of timely blood access. It connects blood donors, recipients, and blood banks using modern technologies to ensure seamless, real-time coordination. The platform features a user-friendly interface for donors to register, search for recipients, and offer blood donations. Recipients can easily find compatible donors and request blood. Blood banks can manage their inventory and facilitate the donation process efficiently.",
    image: BloodLink,
  
    tags: [
      "Next Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Tailwindcss",
      "Google Maps API",
    ],
    category: "web app",
    github: "https://github.com/souvikree/BloodLink",
    webapp: "",
    member: [
      {
        name: "Souvik Ghosh",
        img: "https://avatars.githubusercontent.com/u/143630779?v=4",
        linkedin: "https://www.linkedin.com/in/souvik-ghosh-97a208227/",
        github: "https://github.com/souvikree",
      },
      
    ],
  },
  {
    id: 2,
    title: "Exam Portal",
    date: "July 2024 - August 2024",
    description:
      "",
    image: "",
  
    tags: [
      "React Js",
      "Java",
      "JDBC",
      "Spring Boot",
      "MySQL",
      "Tailwindcss",
    ],
    category: "web app",
    github: "https://github.com/souvikree/ExamPortal",
    webapp: "",
    member: [
      {
        name: "Souvik Ghosh",
        img: "https://avatars.githubusercontent.com/u/143630779?v=4",
        linkedin: "https://www.linkedin.com/in/souvik-ghosh-97a208227/",
        github: "https://github.com/souvikree",
      },
      
    ],
  },
  {
    id: 3,
    title: "EduConnect",
    date: "July 2023 - September 2023",
    description:
    "Educonnect is an e-library project that I am developing to provide a platform for users to access a collection of digital books, articles, and other educational resources.",
    image: EduConnect ,
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Tailwindcss", "Redux", "NodeMailer"],
    category: "web app",
    // github: "https://github.com/souvikree/EduConnect",
    webapp: "https://edu-connect-jade.vercel.app/",
    member: [
      {
        name: "Souvik Ghosh",
        img: "https://avatars.githubusercontent.com/u/143630779?v=4",
        linkedin: "https://www.linkedin.com/in/souvik-ghosh-97a208227/",
        github: "https://github.com/souvikree",
      },
      // {
        //   name: "Chandan Maity",
        //   img: "https://avatars.githubusercontent.com/u/144256228?v=4",
        //   linkedin: "https://www.linkedin.com/in/chandan-maity-4b7643265/",
        //   github: "https://github.com/chandan789maity",
        // },
      ],
    },
    {
      id: 4,
      title: "Insurance Management System",
      date: "November 2024 - December 2024",
      description:
        "The Insurance Management System or Insurance Claim Management System Project using Spring Boot & React Js ensures a seamless experience for all involved. As an administrator, you can easily add multiple Policies in the system by adding the policy details like name, premium amount and the coverage details. After adding the Policies, all the policies will be visible in the home page of the website. And Customers can view all policies details and from there they can apply for the policies. Once Customers apply for any policies, Admin will be able to the see policy applications in his dashboard and from here Admin can accept or reject the application. Here, customer can only apply for the policy application after the login, so from the home page itself customer can register and login themself.",
      image: "",
    
      tags: [
        "React Js",
        "JDBC",
        "Spring Boot",
        "MySQL",
        "Microservices",
      ],
      category: "web app",
      github: "https://github.com/souvikree/Insurance-Management",
      webapp: "",
      member: [
        {
          name: "Souvik Ghosh",
          img: "https://avatars.githubusercontent.com/u/143630779?v=4",
          linkedin: "https://www.linkedin.com/in/souvik-ghosh-97a208227/",
          github: "https://github.com/souvikree",
        },
        
      ],
    },
  {
    id: 5,
    title: "MyShare",
    date: "Jan 2024",
    description:
      "MyShare is a powerful and intuitive file sharing platform designed to make uploading and sharing files easier than ever. With MyShare, you can quickly upload images, documents (DOCX, PDF), and videos through a sleek, user-friendly interface. Plus, once uploaded, files can be easily shared through Facebook, WhatsApp, Gmail, Twitter, LinkedIn, or by copying the link.",
    image: MyShare ,
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Tailwindcss"],
    category: "web app",
    // github: "https://github.com/souvikree/myShare",
    webapp: "https://openmyshare.vercel.app/",
    member: [
      {
        name: "Souvik Ghosh",
        img: "https://avatars.githubusercontent.com/u/143630779?v=4",
        linkedin: "https://www.linkedin.com/in/souvik-ghosh-97a208227/",
        github: "https://github.com/souvikree",
      },
      
    ],
  },
  {
    id: 6,
    title: "Portfolio-Tracker",
    date: "Dec 2024 - Jan 2025",
    description:
      "A full-stack web application for managing stock portfolios, featuring Google OAuth authentication and real-time stock price tracking.",
    image: HomePage,
    tags: [
      "Vite",
      "Google OAuth",
      "React.js",
      "Node.js",
      "MongoDB",
      "Finnhub API",
      "Tailwind CSS",
    ],
    category: "web app",
    github: "https://github.com/souvikree/Portfolio-Tracker",
    webapp: "https://portfolio-tracker-ebon.vercel.app/",
    member: [
      {
        name: "Souvik Ghosh",
        img: "https://avatars.githubusercontent.com/u/143630779?v=4",
        linkedin: "https://www.linkedin.com/in/souvik-ghosh-97a208227/",
        github: "https://github.com/souvikree",
      },
      
    ],
  },
  {
    id: 7,
    title: "Heart Decease Prediction",
    date: "Jan 2024",
    description:
      "A dataset is selected from the UCI repository with patient's medical history and attributes. By using this dataset, we predict whether the patient can have a heart disease or not.",
    // image:
    //   "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    tags: ["Python", "Pandas", "NumPy", "scikit-learn", "KNN classifier"],
    category: "machine learning",
    github: "https://github.com/souvikree/Heart-deases",
   // webapp: "https://brain-tumor.netlify.app/",
   member: [
    {
      name: "Souvik Ghosh",
      img: "https://avatars.githubusercontent.com/u/143630779?v=4",
      linkedin: "https://www.linkedin.com/in/souvik-ghosh-97a208227/",
      github: "https://github.com/souvikree",
    },
    
  ],
  },
  // {
  //   id: 3,
  //   title: "Heart Decease Prediction",
  //   date: "Jan 2024",
  //   description:
  //     "A dataset is selected from the UCI repository with patient's medical history and attributes. By using this dataset, we predict whether the patient can have a heart disease or not.",
  //   // image:
  //   //   "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
  //   tags: ["Python"],
  //   category: "machine learning",
  // },
  // {
  //   id: 4,
  //   title: "Heart Decease Prediction",
  //   date: "Jan 2024",
  //   description:
  //     "A dataset is selected from the UCI repository with patient's medical history and attributes. By using this dataset, we predict whether the patient can have a heart disease or not.",
  //   // image:
  //   //   "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
  //   tags: ["Python"],
  //   category: "machine learning",
  // },
  // {
  //   id: 4,
  //   title: "Heart Decease Prediction",
  //   date: "Jan 2024",
  //   description:
  //     "A dataset is selected from the UCI repository with patient's medical history and attributes. By using this dataset, we predict whether the patient can have a heart disease or not.",
  //   // image:
  //   //   "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
  //   tags: ["Python"],
  //   category: "machine learning",
  // },
  // {
  //   id: 5,
  //   title: "Todo Web App",
  //   date: "Jun 2024",
  //   description:
  //     " A Todo Web App made with React JS. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
  //   // image:
  //   //   "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "web app",
  //   //github: "https://github.com/rishavchanda/Todo-Web-App",
  //  // webapp: "https://rishav-react-todo.netlify.app/",
  // },
  // {
  //   id: 6,
  //   title: "Breaking Bad",
  //   date: "Jun 2021",
  //   description:
  //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
  //   image:
  //     "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
  //   tags: ["React Js", "API", "Axios", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Breaking-Bad",
  //   webapp: "https://breaking-bad-webapp.netlify.app",
  // },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Dec 2020 - Jan 2021",
  //   description:
  //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
  //   image:
  //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
  //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  // },
  // {
  //   id: 8,
  //   title: "Face Recognition",
  //   date: "Jan 2021",
  //   description:
  //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  //   image:
  //     "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // },
];

// export const TimeLineData = [
//   { year: 2017, text: "Started my journey" },
//   { year: 2018, text: "Worked as a freelance developer" },
//   { year: 2019, text: "Founded JavaScript Mastery" },
//   { year: 2020, text: "Shared my projects with the world" },
//   { year: 2021, text: "Started my own platform" },
// ];
